import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { isValidElement, useContext } from 'react';
import clsx from 'clsx';
import Icon from '../icon';
import { isDef } from '../utils';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var Cell = function Cell(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('cell', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var renderLabel = function renderLabel() {
    var showLabel = isDef(props.label);

    if (showLabel) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('label'), props.labelClass)
      }, props.label);
    }

    return null;
  };

  var renderTitle = function renderTitle() {
    if (isDef(props.title)) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('title'), props.titleClass),
        style: props.titleStyle
      }, props.title, renderLabel());
    }

    return null;
  };

  var renderValue = function renderValue() {
    var hasTitle = isDef(props.title);
    var hasValue = props.children || isDef(props.value);

    if (hasValue) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('value', {
          alone: !hasTitle
        }), props.valueClass)
      }, props.children ? props.children : /*#__PURE__*/React.createElement("span", null, props.value));
    }

    return null;
  };

  var renderLeftIcon = function renderLeftIcon() {
    if (typeof props.icon === 'string') {
      return /*#__PURE__*/React.createElement(Icon, {
        name: props.icon,
        className: clsx(bem('left-icon')),
        classPrefix: props.iconPrefix
      });
    }

    if ( /*#__PURE__*/isValidElement(props.icon)) {
      return props.icon;
    }

    return null;
  };

  var renderRightIcon = function renderRightIcon() {
    if (props.rightIcon) {
      return props.rightIcon;
    }

    if (props.isLink) {
      var name = props.arrowDirection ? "arrow-".concat(props.arrowDirection) : 'arrow';
      return /*#__PURE__*/React.createElement(Icon, {
        name: name === 'arrow-right' ? 'arrow' : name,
        className: clsx(bem('right-icon'))
      });
    }

    return null;
  };

  var className = props.className,
      style = props.style,
      size = props.size,
      center = props.center,
      _props$border = props.border,
      border = _props$border === void 0 ? true : _props$border,
      isLink = props.isLink,
      required = props.required,
      onClick = props.onClick;
  var clickable = isLink || props.clickable;
  var classes = {
    center: center,
    required: required,
    clickable: clickable,
    borderless: !border
  };

  if (size) {
    classes[size] = !!size;
  }

  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: clsx(bem(classes), className),
    role: clickable ? 'button' : undefined,
    onClick: onClick
  }, renderLeftIcon(), renderTitle(), renderValue(), renderRightIcon(), props.extra);
};

export default Cell;